import * as React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'


// This is a hacky class and should only be used for testing purposes

const mapStateToProps = (state, initialProps) => ({
    ...initialProps,
    state
})


export const withState = (Wrapped:React.ComponentClass) => connect(mapStateToProps, null)(Wrapped)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/state/index.tsx